import { SET_PAGE_SIZE, TOGGLE_SETTING_BY_KEY } from '@/store/mutationTypes.js';

const state = {
  globalPageSize: 10,
};

const getters = {
  pageSizeOptions: () => [
    3,
    10,
    25,
    50,
    75,
    100,
    150,
    200,
    300,
    400,
    500,
    1000,
  ],
};

const mutations = {
  [SET_PAGE_SIZE]: (state, { size }) => {
    state.globalPageSize = size;
  },

  [TOGGLE_SETTING_BY_KEY]: (state, { key }) => {
    state[key] = !state[key];
  },
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
